import { getJSON, postJSON } from './util';

export const READINGS = {
    fetchSampleInterps: function(product_result_uuid) {
        return getJSON(`/api/product/sample_reading/${product_result_uuid}`);
    },
    submitSample: function(upc, cards, deck, subject) {
        let postString = `deck_code=${deck}&question=${subject || ''}`;

        cards.forEach((card, i) => {
            postString = `${postString}&cards[${i}][card_id]=${card}`;
        });
        return postJSON(`/api/product/submit-sample/${upc}`, postString);
    },
    submitMandala: function(cards, deck, subject, upc, upgrade_slug) {
        const orderInfo = {
            cards: cards,
            deck_code: deck,
            question: subject,
            upgrade_slug: upgrade_slug,
        };

        return postJSON(`/api/product/submit/${upc}`, orderInfo);
    },
    submit: function(cards, deck, subject, upc, upgrade_slug) {
        const orderInfo = {
            cards: cards.map((card) =>
                Object.assign({}, { card_id: card })),
            deck_code: deck,
            question: subject,
            upgrade_slug: upgrade_slug,
        };

        return postJSON(`/api/product/submit/${upc}`, orderInfo);
    },
};

export const RESOLUTIONS = {
    desktop: [1024, 768],
    tablet: [980, 690],
    all: [0, 0],
};

export const DFP = {
    desktop: {
        'Bottom': {
            desktop: [
                [728, 90],
            ],
            tablet: [
                [728, 90],
            ],
            all: [
                [728, 90],
            ],
        },
        'Top': {
            desktop: [
                [728, 90],
                [970, 90],
                [970, 100],
            ],
            tablet: [
                [728, 90],
                [970, 90],
            ],
            all: [
                [728, 90],
                [970, 90],
            ],
        },
        'Rail-1': {
            desktop: [
                [300, 250],
                [300, 600],
            ],
            tablet: [
                [300, 250],
            ],
            all: [
                [300, 250],
            ],
        },
        'Rail-2': {
            desktop: [
                [300, 250],
                [300, 600],
            ],
            tablet: [
                [300, 250],
            ],
            all: [
                [300, 250],
            ],
        },
        'Rail-3': {
            desktop: [
                [300, 250],
            ],
            tablet: [
                [300, 250],
            ],
            all: [
                [300, 250],
            ],
        },
        'Slider': {
            desktop: [
                [728, 90],
            ],
            tablet: [
                [728, 90],
            ],
            all: [
                [728, 90],
            ],
        },
        'PTOTD': {
            desktop: [
                [270, 45],
                [300, 50],
            ],
            tablet: [
                [270, 45],
                [300, 50],
            ],
            all: [
                [270, 45],
                [300, 50],
            ],
        },
    },
    mobile: {
        'Adhesion': {
            all: [
                [300, 100],
                [320, 50],
                [320, 100],
            ],
        },
        'Bottom': {
            all: [
                [300, 100],
                [320, 50],
                [320, 100],
            ],
        },
        'Top': {
            all: [
                [320, 50],
            ],
        },
        'COTD': {
            all: [
                [300, 100],
            ],
        },
        'Middle': {
            all: [
                [300, 250],
            ],
        },
        'Middle-2': {
            all: [
                [300, 250],
            ],
        },
        'PTOTD': {
            all: [
                [270, 45],
                [300, 50],
            ],
        },
    },
};
